let bsParams = {

  proName:'',     // 项目名称
  importantProName:'',
  importantProNameOther:'',     // 重点项目名称其他
  hjLevel:'',     // 获奖级别
  hjLevelOther:'',     // 获奖级别其他
  ydDate:'',     // 拟定完成时间
  remark:'',

	id:'',     // id
	publishId:'',     // 出版单位ID
	publishMaterialId:'',     // publishMaterialId

}

let paramsRule = {

	proName:[
        { required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 项目名称
  importantProName:[
      { required:true, message:'请选择', trigger:'change' },
  ],
  importantProNameOther:[
      { required:true, message:'不能为空！', trigger:'blur' },
      { max:127, message:'填写内容过长！', trigger:'blur' }
  ],
  hjLevel:[
  	  { required:true, message:'请选择', trigger:'change' },
  ],     // 获奖级别
  hjLevelOther:[
      { required:true, message:'不能为空！', trigger:'blur' },
      { max:127, message:'填写内容过长！', trigger:'blur' }
  ],
  ydDate:[
  	  { required:true, message:'请选择', trigger:'change' },
  ],     // 拟定完成时间
  remark:[
      { max:500, message:'填写内容过长！', trigger:'change' }
  ],

}

export { bsParams,paramsRule }



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt6.js